import script from "./Groups.vue?vue&type=script&setup=true&lang=js"
export * from "./Groups.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__